import React from 'react';
import { Redirect } from 'react-router-dom';

const Home = () => (
  <Redirect to={`/channel/${sessionStorage.getItem('channelId')}/groups`} />
);

export default Home;
